<div>
  <p class="attention">ATTENTION!</p>
  <p class="explanation">
    The replacement item is shorter by
    {{
      differenceInMS
        | timecode: channelFramerate : (channelFramerate ? "fps" : "ms") : true
    }}
  </p>

  <div class="actions">
    <p class="option" [ngClass]="{ selected: selectedOption === 0 }">
      <input
        id="rdOption1"
        type="radio"
        name="radiogroup"
        checked="checked"
        (change)="selectedOption = 0; strategyChanged.emit(0)"
      />
      <label for="rdOption1">Pull back rest of playlist (close gap)</label>
    </p>
    <p class="option" [ngClass]="{ selected: selectedOption === 1 }">
      <input
        id="rdOption2"
        type="radio"
        name="radiogroup"
        (change)="selectedOption = 2; strategyChanged.emit(2)"
      />
      <label for="rdOption2"
        >Leave rest of playlist at current position (gap will be created after
        replaced item)</label
      >
    </p>
  </div>
</div>
